import enviro from 'enviro';

const REDDIT_ADS_APP_IDS = {
  QA: 39871483,
  PROD: 43106388,
} as const;

export const REDDIT_ADS_APP_ID = enviro.isQa()
  ? REDDIT_ADS_APP_IDS.QA
  : REDDIT_ADS_APP_IDS.PROD;

const CHATGPT_ADS_APP_IDS = {
  QA: 39872738,
  PROD: 43106479,
} as const;

export const CHATGPT_ADS_APP_ID = enviro.isQa()
  ? CHATGPT_ADS_APP_IDS.QA
  : CHATGPT_ADS_APP_IDS.PROD;

const MICROSOFT_ADS_APP_IDS = {
  QA: 43136430,
  PROD: 47931647,
} as const;

export const MICROSOFT_ADS_APP_ID = enviro.isQa()
  ? MICROSOFT_ADS_APP_IDS.QA
  : MICROSOFT_ADS_APP_IDS.PROD;
